import React, { useEffect, useState } from 'react';
import Loading from '../../components/Loading';
import AuthInstance from '../../Auth/Auth';
import { useHistory } from 'react-router-dom';
import { fetchUserInfo } from '../../services/user/actions';
import { getProfile } from '../../services/studentActions/profile/actions';
import { useDispatch } from 'react-redux';

const Callback = () => {

  const stateUrl = sessionStorage.getItem('ROUTE_STATE');

  const dispatch = useDispatch();
  const history = useHistory();
  const [authResult, setAuthResult] = useState({} as any);
  const [userInfo, setUserInfo] = useState(null as any);
  
  const handleAuthenticationError = (err:any) => {
    if (err && err.errorDescription === "Please verify your email before logging in.") {
      history.push('/verifyEmail');
    } else {
      history.push('/');
    }
  }

  useEffect(() => {

    const authenticateUser = async () => {
      try {
        const authResult = await AuthInstance.handleAuthentication();
        setAuthResult(authResult);
        await fetchUserInfo();
        const userResult = await dispatch(getProfile());
        setUserInfo(userResult);
      } catch (err) {
        handleAuthenticationError(err)
      }
    }

    if (/access_token|id_token|error/.test(history.location.hash)) {
      authenticateUser();
    }
  }, [])

  if ( userInfo ) {
    if ( userInfo.country && userInfo.fullName && userInfo.email && userInfo.gender) {
      if (authResult.state && authResult.state === stateUrl){
        history.push(authResult.state);
      } else {
        history.push('/student')
      }
    } else {
      if ( authResult.state && authResult.state !== '/') {
        history.push(`/signUpInfo?redirectUrl=${authResult.state}`)
      } else {
        history.push(`/signUpInfo`)
      }
    }
  }

  return <Loading pastDelay={true} className="loader-wrap big-loader"/>
}

export default Callback;